import React, { Suspense, useEffect, useRef } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { ReactQueryDevtools } from 'react-query-devtools';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import PageTraining from '@/components/page/training';
import UILoader from '@/components/ui/loader';
import PageLayout from './layout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PageNotFound = dynamic(function () {
  return import('@/components/page/not-found');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('@/components/page/not-found')];
    }
  }
});

var PageRouteWebApp = function PageRouteWebApp(_ref) {
  var location = _ref.location;
  var router = useRouter();
  useEffect(function () {
    if (router.asPath === '/') router.replace('/training');
  }, [router.asPath]);
  return /*#__PURE__*/_jsxs(Switch, {
    location: location,
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/training",
      children: /*#__PURE__*/_jsx(PageTraining, {})
    }), /*#__PURE__*/_jsx(Route, {
      children: router.asPath !== '/' && /*#__PURE__*/_jsx(PageNotFound, {})
    })]
  });
};

var Page = function Page() {
  var nextRouter = useRouter();
  var history = useHistory();
  var location = useLocation();
  var prevLocation = useRef(location);

  var componentDidUpdate = function componentDidUpdate() {
    if (history.action !== 'POP' && !nextRouter.query.popup) {
      prevLocation.current = location;
    }
  };

  useDocumentTitle('Motimate');
  useEffect(componentDidUpdate);
  return /*#__PURE__*/_jsxs(Suspense, {
    fallback: /*#__PURE__*/_jsx(UILoader, {}),
    children: [/*#__PURE__*/_jsx(PageLayout, {
      variant: "enterprise",
      children: /*#__PURE__*/_jsx(PageRouteWebApp, {
        location: location
      })
    }), /*#__PURE__*/_jsx(ReactQueryDevtools, {
      initialIsOpen: false
    })]
  });
};

export default Page;